<div class="generic-container contact">
    <div class="contact-details">
        <section class="section conatct-info">
            <p class="section-title">{{ "contact.contactDetails.contactInfo" | translate }}</p>
            <p>{{ "contact.contactDetails.phone" | translate }}</p>
            <p>{{ "contact.contactDetails.email" | translate }}</p>
        </section>
        <section class="section office-location">
            <h3 class="section-title">{{ "contact.contactDetails.officeLocation" | translate }}</h3>
            <p class="address">{{ "contact.contactDetails.officeAddress" | translate }}</p>
        </section>
        <section class="section working-hours">
            <p class="section-title">{{ "contact.contactDetails.workingHours" | translate }}</p>
            <p>{{ "contact.contactDetails.weekdays" | translate }}</p>
            <p>{{ "contact.contactDetails.weekendSat" | translate }}</p>
            <p>{{ "contact.contactDetails.weekendSun" | translate }}</p>
        </section>
    </div>
    <div class="contact-form">
        <p class="contact-form-title">{{ "contact.heading.contactHeading" | translate }}</p>
        <p class="contact-form-desc">
            {{ "contact.contactDetails.headline" | translate }}
        </p>
        <div class="form">
            <form [formGroup]="contactForm" (ngSubmit)="onSubmit()">
                <div class="fields">
                    <div class="input-field">
                        <label for="name" class="required">{{ "contact.label.name" | translate }}</label>
                        <input
                            id="name"
                            type="text"
                            formControlName="name"
                            [placeholder]="'contact.placeholder.name' | translate"
                        />
                        <div *ngIf="isInvalid('name')">
                            <p class="error-text" *ngIf="isInvalid('name', 'required')">
                                {{ "contact.label.name" | translate }}
                                {{ "contact.invalidMessage.mandatory" | translate }}
                            </p>
                            <p class="error-text" *ngIf="isInvalid('name', 'forbiddenName')">
                                {{ "contact.label.name" | translate }}
                                {{ "contact.invalidMessage.numberSpecialInvalid" | translate }}
                            </p>
                        </div>
                    </div>
                    <div class="row">
                        <div class="input-field email">
                            <label for="email" class="required">{{ "contact.label.email" | translate }}</label>
                            <input
                                id="email"
                                type="text"
                                formControlName="email"
                                [placeholder]="'contact.placeholder.email' | translate"
                            />
                            <div *ngIf="isInvalid('email')">
                                <p class="error-text" *ngIf="isInvalid('email', 'required')">
                                    {{ "contact.label.email" | translate }}
                                    {{ "contact.invalidMessage.mandatory" | translate }}
                                </p>
                                <p
                                    class="error-text"
                                    *ngIf="isInvalid('email', 'invalidEmail') && !isInvalid('email', 'required')"
                                >
                                    {{ "contact.invalidMessage.emailInvalid" | translate }}
                                </p>
                            </div>
                        </div>
                        <div class="input-field subject">
                            <label for="subject" class="required">{{ "contact.label.subject" | translate }}</label>
                            <input
                                id="subject"
                                type="text"
                                formControlName="subject"
                                [placeholder]="'contact.placeholder.subject' | translate"
                            />
                            <div *ngIf="isInvalid('subject')">
                                <p class="error-text" *ngIf="isInvalid('subject', 'required')">
                                    {{ "contact.label.subject" | translate }}
                                    {{ "contact.invalidMessage.mandatory" | translate }}
                                </p>
                            </div>
                        </div>
                    </div>

                    <div class="input-field">
                        <label for="message" class="required">{{ "contact.label.message" | translate }}</label>
                        <textarea
                            id="message"
                            type="text"
                            formControlName="message"
                            rows="5"
                            [placeholder]="'contact.placeholder.message' | translate"
                        ></textarea>
                        <div *ngIf="isInvalid('message')">
                            <p class="error-text" *ngIf="isInvalid('message', 'required')">
                                {{ "contact.label.message" | translate }}
                                {{ "contact.invalidMessage.mandatory" | translate }}
                            </p>
                        </div>
                    </div>
                </div>
                <div class="save-btn">
                    <button mat-flat-button [disabled]="this.contactForm.invalid" class="save-btn">
                        {{ "contact.button.submitBtn" | translate }}
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
